import { useDrawer } from 'src/hooks/useDrawer';
import { twJoin } from 'tailwind-merge';
import { LinksList } from '../LinksList';
import { LogOutButton } from '../LogOutButton';
import { Head } from './components/Head';

export const AccountHeader = () => {
  const { isTopDrawerOpen, toggleTopDrawer } = useDrawer();

  return (
    <div className="w-full bg-bg_main px-2 relative h-11">
      <div
        className="w-full font-bold text-base bg-tn_bg rounded-lg cursor-pointer"
        onClick={toggleTopDrawer}>
        <Head isTopDrawerOpen={isTopDrawerOpen} />
        <div
          className={twJoin(
            'w-full landscape:overflow-y-scroll landscape:max-h-[170px] flex flex-col justify-center items-center gap-3 pb-3 px-5',
            isTopDrawerOpen ? 'block' : 'hidden'
          )}>
          <LinksList />
          <LogOutButton />
        </div>
      </div>
    </div>
  );
};
